import type { Snapshot } from '@ember-data/legacy-compat/-private';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import type { BeniSmartCompset } from 'lumen/models';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class BeniSmartCompsetSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    categories: { embedded: 'always' },
    marketComposition: { embedded: 'always' },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: BeniSmartCompset,
    id: string | number,
    requestType: string,
  ) {
    const normalizedPayload = {
      'benchmark-insight/competitors/smart-compset': payload,
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalizeResponse(
      store,
      primaryModelClass,
      normalizedPayload,
      id,
      requestType,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  serialize(
    snapshot: Snapshot,
    options: { excludeUnchangedAttributes: boolean },
  ) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const payload: Record<string, unknown> = super.serialize(snapshot, options);
    const reducedPayload: Record<string, unknown> = {};
    reducedPayload['categories'] = payload['categories'];
    return reducedPayload;
  }

  serializeIntoHash(
    hash: BeniSmartCompset,
    _ModelClass: unknown,
    snapshot: Snapshot,
    options: { excludeUnchangedAttributes: boolean },
  ): void {
    /*
          By default, the payload for saving a record would be:
          {
              beniSmartCompset: {
                  categories: true
              }
          }

          Instead, we want the payload to be:
          {
              categories: true
          }
      */
    const serializedData = this.serialize(snapshot, options);
    Object.assign(hash, serializedData);
  }
}
